import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { AddEntityItem, AddEntityText, CampaignAndGroupSelectorEntityToSelectType } from '../../typings/sidebar';
import { BetaMark } from '../BetaMark/BetaMark';

import './AddEntityMenu.css';
import * as keyset from './AddEntityMenu.i18n';

const i18n = i18nFactory(keyset);

export interface AddEntityMenuProps {
    startAddEntity: (item: AddEntityItem) => void;
    items: AddEntityItem[];
    limit: number;
}

export class AddEntityMenu extends React.Component<AddEntityMenuProps> {
    static EntityItems = React.memo(
        ({
            items,
            startAddEntity,
            limit
        }: {
            items: AddEntityItem[];
            startAddEntity: (item: AddEntityItem) => void;
            limit: number;
        }) => {
            return (
                <>
                    {items.map((item, index) => {
                        return (
                            <AddEntityMenu.EntityItem
                                key={index}
                                item={item}
                                index={index}
                                limit={limit}
                                startAddEntity={startAddEntity}
                            />
                        );
                    })}
                </>
            );
        }
    );

    static EntityItem = React.memo(
        ({
            item,
            index,
            limit,
            startAddEntity
        }: {
            item: AddEntityItem;
            index: number;
            limit: number;
            startAddEntity: (item: AddEntityItem) => void;
        }) => {
            const { title, description } = AddEntityMenu.getTitleAndDescription(item, limit);

            const onClick = () => {
                return startAddEntity(item);
            };

            return (
                <div className={Bem.cls('add-entity-menu', 'menu-item')} key={index} onClick={onClick}>
                    <div className={Bem.cls('add-entity-menu', 'menu-item-title')}>{title}</div>
                    <div className={Bem.cls('add-entity-menu', 'menu-item-description')}>{description}</div>
                </div>
            );
        }
    );

    static getTitleAndDescription(type: AddEntityItem, limit: number): AddEntityText {
        switch (type) {
            case CampaignAndGroupSelectorEntityToSelectType.BANNER:
                return {
                    title: i18n('ad'),
                    description: i18n('ad-description')
                };
            case CampaignAndGroupSelectorEntityToSelectType.CAMPAIGN:
                return {
                    title: i18n('campaign'),
                    description: i18n('campaign-description')
                };
            case CampaignAndGroupSelectorEntityToSelectType.PHRASE:
                return {
                    title: i18n('phrase'),
                    description: i18n('phrase-description')
                };
            case CampaignAndGroupSelectorEntityToSelectType.PHRASE_BETA:
                return {
                    title: [i18n('phrase'), <BetaMark key="beta-mark-key" />],
                    description: i18n('phrase-description')
                };
            case CampaignAndGroupSelectorEntityToSelectType.GROUP:
                return {
                    title: i18n('group'),
                    description: i18n('group-limit-description', {
                        limit
                    })
                };
            default:
                throw new Error('AddEntityValue is not supported!');
        }
    }

    render() {
        const { items, startAddEntity, limit } = this.props;

        return (
            <div className={Bem.cls('add-entity-menu')}>
                <div className={Bem.cls('add-entity-menu', 'title')}>{i18n('add')}</div>

                <div className={Bem.cls('add-entity-menu', 'menu')}>
                    <AddEntityMenu.EntityItems items={items} startAddEntity={startAddEntity} limit={limit} />
                </div>
            </div>
        );
    }
}
